// Predicate-generating function. Often useful outside of Underscore.
export default function noop(){}



//////////////////
// WEBPACK FOOTER
// ./node_modules/underscore/modules/noop.js
// module id = 280
// module chunks = 0